import axios from 'axios';
import { BASE_URL } from 'app/utils/apiConfig';
import { store } from 'app/redux/Store';
import { userLoggedOut } from 'app/redux/auth/authSlice';
import { clearActiveClient } from 'app/redux/client/activeClientSlice';
export { BASE_URL } from 'app/utils/apiConfig';
const api = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the Bearer token from 'auth_user'
api.interceptors.request.use(
  (config) => {
    const authDataRaw = localStorage.getItem('auth_user');
    let token;
    if (authDataRaw) {
      try {
        const authData = JSON.parse(authDataRaw);
        token = authData?.accessToken;
      } catch (e) {
        token = undefined;
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle expired/invalid sessions
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      try {
        // Clear auth state & localStorage
        store.dispatch(userLoggedOut());
        store.dispatch(clearActiveClient());
      } catch (e) {
        // ignore dispatch errors
      }

      // Redirect to login if not already on a session route
      const currentPath = window.location.pathname || '';
      if (!currentPath.startsWith('/sessions/')) {
        window.location.href = '/sessions/signin';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
